jQuery(document).ready(function($){
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
  };

  var head_height = $('.section-header').innerHeight();
  var nav_height = $('.section-navig').innerHeight();

  //# Target Scroll
  $('a[href*="#"]:not([href="#"])').click(function(e) {
    e.preventDefault();
    var target = $(this.hash);
    $('html,body').stop().animate({
      scrollTop: target.offset().top - head_height - nav_height
    }, 'linear');   
  });
  
  //# Target blank
  $('a[href="#"],a[href=""]').click(function(e) {
    e.preventDefault();
  });

  //Mobile Navigation Open
  $('.mob_nav').on('click', '.mob_nav_icon.navopen_icon',function(e) {
    e.preventDefault();
    $('.mob_navig').addClass('mob_navig_active');
    $(this).parent('.mob_nav').addClass('mob_nav_active');
  });
  //Mobile Navigation Close
  $('.mob_nav').on('click', '.mob_nav_icon.navclose_icon',function(e) {
    e.preventDefault();
    $('.mob_navig').removeClass('mob_navig_active');
    $(this).parent('.mob_nav').removeClass('mob_nav_active');
  });

  //Mobile Navigation Close
  // $('.mob_navig').on('click', '.mob_navig_close', function(e) {
  //   e.preventDefault();
  //   $('.mob_navig').removeClass('mob_navig_active');
  //   $('.navig_dropdown').removeClass('navig_dropdown_active');
  //   $('.navig_subdropdown').removeClass('navig_subdropdown_active');
  // });

  //Mobile SubMenu Open
  $('.mob_navig_inner .navig_li').on('click', '.has_dropdown', function(e) {
    e.preventDefault();
    $(this).siblings('.navig_dropdown').toggleClass('navig_dropdown_active');
    $(this).siblings('.navig_dropdown').slideToggle('medium','linear');
  });

  //Mobile SubMenu - MainMenu 
  // $('.navig_dropdown .mob_nav_subhead').on('click', '.navig_dropdown_left',function(e) {
  //   e.preventDefault();
  //   $(this).parents('.navig_dropdown').removeClass('navig_dropdown_active');
  // });

  //Mobile SubSubMenu Open
  $('.mob_navig_inner .navig_li').on('click', '.has_subdropdown',function(e) {
    e.preventDefault();
    $(this).siblings('.navig_subdropdown').toggleClass('navig_subdropdown_active');
    $(this).siblings('.navig_subdropdown').slideToggle('medium','linear');
  });

  //Mobile SubSubMenu - SubMenu 
  // $('.navig_subdropdown .mob_nav_subsubhead').on('click', '.navig_subdropdown_left',function(e) {
  //   e.preventDefault();
  //   $(this).parents('.navig_subdropdown').removeClass('navig_subdropdown_active');
  // });

  //Search Popup on Mobile Open
  // $('.header_search').on('click', '.mob_search_icon',function(e) {
  //   e.preventDefault();
  //   $(this).siblings('.search_form').slideToggle('fast','linear');
  // });

  //Footer Navigation Mobile
  $('.footer_navig_ul').on('click', '.footer_navig_haschild',function(e) {
    if($(document).width() < 1025) {
      e.preventDefault();
      if($(this).siblings('.footer_navig_child_ul').hasClass('footer_navig_child_active')){
        $(this).siblings('.footer_navig_child_ul').removeClass('footer_navig_child_active');
        $(this).siblings('.footer_navig_child_ul').slideToggle('medium','linear');
      } else {
        $('.footer_navig_child_active').not($(this).siblings('.footer_navig_child_ul')).slideToggle('medium','linear');
        $('.footer_navig_child_active').not($(this).siblings('.footer_navig_child_ul')).removeClass('footer_navig_child_active');
        $(this).siblings('.footer_navig_child_ul').addClass('footer_navig_child_active');
        $(this).siblings('.footer_navig_child_ul').slideToggle('medium','linear');
      }
    }
  });

  //BioMarker Popup on Open
  $('.biomark_list').on('click', '.biomark_list_btn',function(e) {
    e.preventDefault();
    $(this).parent('.biomark_list_cont').siblings('.biomark_popup').addClass('biomark_popup_active');
  });

  //BioMarker Popup on Close
  $('.biomark_popup').on('click', '.biomark_popup_close',function(e) {
    e.preventDefault();
    $(this).parents('.biomark_popup').removeClass('biomark_popup_active');
  });

  //BioMarker Popup on Close Outside
  $('.biomark_list').on('click', '.biomark_popup_active', function(e) {
    var container = $(".biomark_popup_inner");

    // if the target of the click isn't the container nor a descendant of the container
    if(!container.is(e.target) && container.has(e.target).length === 0) {
      $(this).removeClass('biomark_popup_active');
    }
  });

  //Variant Popup on Open
  $('.prod_variant').on('click', '.var_link',function(e) {
    e.preventDefault();
    var var_rel = $(this).attr('data-attr');
    $(this).parents('.mproduct_variant').siblings('.variant_description[data-rel="'+var_rel+'"]').removeClass('hidden');
  })

  //Variant Popup on Close
  $('.variant_description').on('click', '.variant_description_close',function(e) {
    e.preventDefault();
    $(this).parents('.variant_description').addClass('hidden');
  });

  //Video Play on Click
  $('.video_play').click(function(e) {
    e.preventDefault();
    var text = $(this).parents('.video_thumbnail_img').siblings('iframe')[0].src;
    text = text.replace("autoplay=0", "autoplay=1&mute=1");
    $(this).parents('.video_thumbnail_img').siblings('iframe').remove();
    $(this).parents('.video_media').append('<iframe allow="autoplay;" src="'+ text +'"></iframe>');
    setTimeout(() => { 
      $(this).parents('.video_thumbnail_img').addClass('disp_none');
    }, 1000);
  });

  //SlideShow Contact Form Popup
  $('.slideshow_infobox').on('click', '.form_click', function(e) {
    e.preventDefault();
    $(this).parents('.slideshow_infobox').find('.slideshow_infobox_contbox').slideToggle('medium','linear');
    $(this).parents('.slideshow_infobox').find('.slideshow_cform').slideToggle('medium','linear');
  });

  //SlideShow Info Close
  $('.slideshow_infobox').on('click', '.slideshow_close_info', function(e) {
    e.preventDefault();
    $(this).parents('.slideshow_infobox').slideToggle('medium','linear');
  });

  // FAQ's Active Classes
  $('.faq_list').on('click','.faq_list_head', function(e){
    e.preventDefault();
    if($(this).parent('.faq_list').hasClass('faq_list_active')){
      $(this).parent('.faq_list').removeClass('faq_list_active');
      $(this).siblings('.faq_answer').slideToggle('medium','linear');
    } else {
      $(this).parent('.faq_list').addClass('faq_list_active');
      $(this).siblings('.faq_answer').slideToggle('medium','linear');
      $(this).parent('.faq_list').siblings('.faq_list_active').find('.faq_answer').slideToggle('medium','linear');
      $(this).parent('.faq_list').siblings('.faq_list_active').removeClass('faq_list_active');
    }
  });

  // More Info Active Classes
  $('.bl_moreinfo_inner').on('click','.bl_moreinfo_head', function(e){
    e.preventDefault();
    if($(this).parent('.bl_moreinfo_inner').hasClass('bl_moreinfo_active')){
      $(this).parent('.bl_moreinfo_inner').removeClass('bl_moreinfo_active');
      $(this).siblings('.bl_moreinfo_cont').slideToggle('medium','linear');
    } else {
      $(this).parent('.bl_moreinfo_inner').addClass('bl_moreinfo_active');
      $(this).siblings('.bl_moreinfo_cont').slideToggle('medium','linear');
    }
  });

  //Product Description Read More...
  $('.mproduct_descript_box').on('click','.mproduct_dec_readmore', function(e) {
    $(this).parents('.mproduct_descript_box').addClass('mproduct_descript_active');
    $(this).parent('.mproduct_shortdescript').siblings('.mproduct_fulldescript').slideToggle('medium','linear');
  });

  //Product Description Read Less...
  $('.mproduct_descript_box').on('click','.mproduct_dec_readless', function(e) {
    $(this).parents('.mproduct_descript_box').removeClass('mproduct_descript_active');
    $(this).parent('.mproduct_fulldescript').slideToggle('medium','linear');
  });
  var selectedvarprice = $('.mproduct_variant fieldset label input:checked').siblings('.var_price').text();
  var varid1 = $('.mproduct_variant fieldset label input:checked').siblings('.var_price').attr('data-id');
  //var selectedvarprice = $('#prod_vars').find(":selected").val();
  //var varid1 = $('#prod_vars').find(":selected").attr('data-price');
  setTimeout(function () {
    $('div.single_liner_messages').addClass('hidden');
    $('div#variant_'+varid1).removeClass('hidden');
    $('div.variant_desc_wrapper').addClass('hidden');
    $('div[data-mid="'+varid1+'"]').removeClass('hidden');
    $('.mproduct_buybtn .product-form__submit').find('.btn_price').html('('+selectedvarprice+')');
    $('div#variant_'+varid1).removeClass('hidden');
    console.log(selectedvarprice);
  }, 1000);
  //Product Price
  var product_btnprice = '';
  $('.mproduct_variant fieldset label').each(function(){
    if($(this).find('input').is(':checked')) {
      var product_btnprice = $(this).find('.var_price').text();
      //$('.mproduct_buybtn .product-form__submit').find('.btn_price').text('('+product_btnprice+')');
      var varid = $(this).find('.var_price').attr('data-id');
      
      $('div.single_liner_messages').addClass('hidden');
      $('div#variant_'+varid).removeClass('hidden');
    }
  });
  $('.mproduct_info').on("click",'.mproduct_variant fieldset label', function(e) {
      //$('.mproduct_buybtn .product-form__submit').find('.btn_price').text('');
      setTimeout(function () {
        var varid = getUrlParameter('variant');
        //console.log(varid);
        var selectedvarprice = $('#prod_vars option[data-price="'+varid+'"]').val();
        $('.mproduct_buybtn .product-form__submit').find('.btn_price').html('('+selectedvarprice+')');
        $('div.variant_desc_wrapper').addClass('hidden');
        $('div[data-mid="'+varid+'"]').removeClass('hidden');
        $('div.single_liner_messages').addClass('hidden');
        $('div#variant_'+varid).removeClass('hidden');
      }, 1000);
      var product_btnprice = $('.mproduct_variant fieldset label input:checked').siblings('.var_price').text();
      var product_btnprice = $(this).find('.var_price').text();
      //$('.mproduct_buybtn .product-form__submit').find('.btn_price').text('('+product_btnprice+')');
      //console.log(product_btnprice);
      var varid = $(this).find('.var_price').attr('data-id');
      $('div.single_liner_messages').addClass('hidden');
      $('div#variant_'+varid).removeClass('hidden');
  })
  
  //See Pricing Structure(Mounjaro) on Click
  $('.m-pop').on('click', function(e) {
    e.preventDefault();
    $(this).next('.pricing-popup-overlay').addClass('pricing-popup-active');
  });

  //See Pricing Structure(Mounjaro) on Close
  $('.close-popup').on('click', function(e) {
    e.preventDefault();
    $(this).parents('.pricing-popup-overlay').removeClass('pricing-popup-active');
  });

  //See Pricing Structure(Wegovy) on Click
  $('.w-pop').on('click', function(e) {
    e.preventDefault();
    $(this).next('.pricing-popup-overlay').addClass('pricing-popup-active');
  });

  //See Pricing Structure(Wegovy) on Close
  $('.close-wegovy').on('click', function(e) {
    e.preventDefault();
    $(this).parents('.pricing-popup-overlay').removeClass('pricing-popup-active');
  });

  //Change Variant
  $('.mounjaro-variant-selector').on('change', function(e) {
    e.preventDefault();
    $(this).siblings('.ptab-note').removeClass('ptab-note-active');
    var get_data = $(this).find(":selected").attr('data-title');
    if(get_data!="2.5mg") {
      $(this).siblings('.ptab-note').addClass('ptab-note-active');
    }
  });
  
  //Change Variant
  $('.wegovy-variant-selector').on('change', function(e) {
    e.preventDefault();
    $(this).siblings('.ptab-note').removeClass('ptab-note-active');
    var get_data = $(this).find(":selected").attr('data-title');
    if(get_data!="0.25mg") {
      $(this).siblings('.ptab-note').addClass('ptab-note-active');
    }
  });

  // CP logo click
  $('span#cp_logo').on('click', function(){
    $('div.clear_pay_modal').removeClass('hidden');
  });

  $('button.afterpay-close-button').on('click', function(){
    $('div.clear_pay_modal').addClass('hidden');
  });

  // Contact form submission
    $('button#form_submit').click(function(e){
    e.stopPropagation();
      let allAreFilled = true;
      document.getElementById("ContactFormReg").querySelectorAll("[required]").forEach(function(i) {
        if (!allAreFilled) return;
        if (!i.value) { allAreFilled = false;  i.setCustomValidity('This field is required');  i.reportValidity(); }
      })
      if (allAreFilled) {
          $(this).attr('disabled', true);
          var alldata = $('form#ContactFormReg').serialize();
          var settings = {
              "url": "https://api.gbc.health/v1/shopify-reg-of-interest",
              "method": "POST",
              "crossDomain": true,
              "timeout": 0,
              "data": JSON.stringify({
                  "data": alldata,
              }),
            };
            $.ajax(settings).done(function (response) {
              console.log('done');
              
            });
            setTimeout(function(){
                console.log(JSON.stringify(alldata));
                $('form#ContactFormReg').submit();
              }, 1000);
          

        
      }
  });
});

document.addEventListener("DOMContentLoaded", function () {
    const field = document.getElementById('cluid');

    // Only run if the field exists
    if (!field) return;
    
    const uid = window?.CLabsgbVar?.generalProps?.uid;

    if (uid) {
        field.value = uid;
        console.log(uid);
    } else {
        console.warn("CLabsgbVar.generalProps.uid is not available yet");
    }
    // Check that the global variable exists safely
    
});